import keyMirror from 'keymirror';

const GIFT_CARD_TYPES = keyMirror({
  MCO: null,
  UATP: null,
});

export default GIFT_CARD_TYPES;
